import { useConnector, useInstantSearch } from 'react-instantsearch';
import { FormattedMessage } from 'react-intl';

import { Switch } from '@sorare/core/src/atoms/inputs/Switch';
import { SBHorizontal } from '@sorare/core/src/atoms/layout/flex';
import { FilterTitle } from '@sorare/core/src/components/search/FilterTitle';
import type { ExtendedUIState } from '@sorare/core/src/components/search/InstantSearch/types';
import { connectExcludeFilter } from '@sorare/core/src/components/search/connectors/connectExcludeFilter';
import { FILTERS } from '@sorare/core/src/lib/filters';
import { filters } from '@sorare/core/src/lib/glossary';

const FILTER = FILTERS.collectible;
const CollectibleFilter = () => {
  const { value, refine } = useConnector(connectExcludeFilter, {
    facet: 'rarity',
    excluded: 'custom_series',
    searchParam: FILTER.alias,
  });

  return (
    // eslint-disable-next-line jsx-a11y/label-has-associated-control
    <label className="FilterWidget visible">
      <SBHorizontal>
        <FormattedMessage {...FILTER.title} />
        <Switch
          checked={value}
          onChange={e => {
            refine(e.target.checked);
          }}
        />
      </SBHorizontal>
    </label>
  );
};

const Title = () => {
  const {
    indexUiState: { exclusions: { [FILTER.alias]: filterChecked } = {} },
  } = useInstantSearch<ExtendedUIState>();

  return (
    <FilterTitle
      name={filters.collectibleFilterTitle}
      selected={filterChecked ? 1 : 0}
    />
  );
};

export const widget = {
  key: FILTER.alias,
  attribute: '',
  type: 'toggle' as const,
  title: <Title />,
  Component: CollectibleFilter,
};
